var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-indigo rounded-circle d-flex justify-content-center align-items-center",style:({width: _vm.width, height: _vm.height})},[_c('span',{staticClass:"text-white fs-2"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }